import { configureStore } from "@reduxjs/toolkit";
import drawerReducer from "./reducers/opendrawer";
import orderReducer from "./reducers/activeorders";
import adminReducer from "./reducers/admin";
import categoryReducer from "./reducers/category";
import conductTestReducer from "./reducers/conductTest";
import studentConsultationReducer from "./reducers/consultation";
import auhtReducer from "./reducers/loggedinuser";
import rewardsReducer from "./reducers/rewards";
import teacherSubjectsReducer from "./reducers/subjectTutor";
import newTestReducer from "./reducers/test";
import testReducer from "./reducers/trainee";
import userReducer from "./reducers/traineestate";
import userComponentReducer from "./reducers/traineestatecomponent";
import questionsReducer from "./reducers/trainer";
import forgotPassword from "./reducers/forgotPassword"

const store = configureStore({
  reducer: {
    drawer: drawerReducer,
    orders: orderReducer,
    admin: adminReducer,
    category: categoryReducer,
    conductTest: conductTestReducer,
    studentConsultation: studentConsultationReducer,
    auth: auhtReducer,
    rewards: rewardsReducer,
    teacherSubjects: teacherSubjectsReducer,
    test: newTestReducer,
    trainee: testReducer,
    user: userReducer,
    userComponent: userComponentReducer,
    trainer: questionsReducer,
    reset:forgotPassword
  },
});

export default store;
